// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"50":"views-my","625":"views-admin","727":"views-public"}[chunkId] || chunkId) + "." + {"50":"2e42134a","51":"3a338a6e","625":"55c1c0fa","727":"cf6cdd87"}[chunkId] + ".js";
};